import {module as m} from 'modujs';
import Swiper, { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import {StoreSingleton} from "../../singletons/store";
import gsap from "gsap";

export default class extends m {
    constructor(m) {
        super(m);

        // VAR
        this.swiper = null;
        this.currentIndex = 0;
        this.previousIndex = 0;
        this.isProcessing = false;

        // EVENTS
        this.events = {
            click: {
                prev: '_prev',
                next: '_next',
            }
        }
    }

    /**
     * INIT
     */
    init() {
        if(this.$('item').length > 1)
            this.$('arrows')[0].style.display = "flex";

        if(StoreSingleton.isMobile) {
            this.swiper = new Swiper(this.$('swiper')[0], {
                slidesPerView: 1,
                autoHeight: true,
                pagination: {
                    el: '.swiper-pagination',
                },
                modules: [Pagination],
            });
        }
    }

    /**
     * PREV
     * @private
     */
    _prev() {
        if(!this.isProcessing) {
            this.isProcessing = true;
            this.previousIndex = this.currentIndex;

            if(this.currentIndex > 0)
                this.currentIndex--;
            else
                this.currentIndex = this.$('item').length - 1;

            this._slide();
        }
    }

    /**
     * NEXT
     * @private
     */
    _next() {
        if(!this.isProcessing) {
            this.isProcessing = true;
            this.previousIndex = this.currentIndex;

            if(this.currentIndex < this.$('item').length - 1)
                this.currentIndex++;
            else
                this.currentIndex = 0;

            this._slide();
        }
    }

    /**
     * SLIDE
     * @private
     */
    _slide() {
        const _tl = gsap.timeline({
            onComplete: () => {
                this.isProcessing = false;
            }
        });
        _tl.set(this.$('item')[this.currentIndex], {
            alpha: 0,
            yPercent: 10,
        });
        _tl.to(this.$('item')[this.previousIndex], {
            duration: 0.6,
            alpha: 0,
            yPercent: -10,
            ease: 'power4.in'
        });
        _tl.to(this.$('item')[this.currentIndex], {
            duration: 0.6,
            alpha: 1,
            yPercent: 0,
            ease: 'power4.out'
        }, 0.5);
    }
}
